<template lang="pug">
div
  v-alert(v-for="alert in alerts" :type="alert.status" :key="alert.id")
    span(v-html="alert.alert_text") 
</template>

<script>
import service from '../data/service'

export default {
  data: () => ({
    alerts: []
  }),
  methods: {
    getAlerts() {
      return service.listAlerts().then(data => {
        this.alerts = data.data.listAlerts
      })
    }
  },
  mounted() {
    this.getAlerts()
  }
}
</script>